import { selector } from "recoil";
import { userConfigState } from "./UserConfigState";

export const timeZoneSelector = selector({
  key: 'timeZoneSelector',
  get: ({get}) => {
    const timeZone = get(userConfigState('time_zone'));
    if (timeZone) {
      return timeZone;
    }
    const timeZoneOffset = (new Date()).getTimezoneOffset();
    return timeZoneOffset === -540 ? 'Asia/Tokyo' : 'utc';
  },
  set: ({set}, timeZone) => {
    set(userConfigState('time_zone'), timeZone);
  }
});
